import FunctionalButton from "components/layout/FunctionalButton";
import { useTranslation } from "react-i18next";
import { useDocking } from "providers/DockingProvider";
import { useDockingUiVisible } from "lib/hooks/useDockingUiVisible";

import { ReactComponent as DockingIcon } from "assets/svgs/docking.svg";

const DockingButton = () => {
    const { t } = useTranslation("control");
    const dockingUiVisible = useDockingUiVisible();
    const { isDocked, actionStatus, triggerDocking } = useDocking();

    if (!dockingUiVisible) return null;

    // Match EstopToggleButton engaged styling when docked (press = undock).
    const className = isDocked
        ? "control-button-type1 bg-red-500 text-white ring-2 ring-red-300/90"
        : "control-button-type1 bg-black100";

    const hoverText = isDocked ? t("buttons.undock") : t("buttons.dock");

    return (
        <FunctionalButton
            icon={<DockingIcon className="h-7 w-7 shrink-0 text-white" />}
            className={className}
            hoverText={hoverText}
            disabled={actionStatus === "active"}
            onClick={triggerDocking}
            aria-pressed={isDocked}
        />
    );
};

export default DockingButton;
